import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ErrorDetails, ICarrierAreaResponseDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class SearchCarrierAreasCommand
    extends IRequestCommand<
    ICarrierAreaResponseDTO,
    ErrorDetails,
    ICarrierAreasSearchRequest
    > {
    override _commandType: CommandRequestType = CommandRequestType.GET;

    public override setParameters(parameters: ICarrierAreasSearchRequest) {
        this.urlSections.push('carriers');
        this.urlSections.push(`${parameters.carrierId}`);
        this.urlSections.push('carrierArea');
        if(parameters.excludeOperationAreasInUse){
          this.paramsSections.push('excludeOperationAreasInUse=true')
        }
        if(parameters.opeType){
            this.paramsSections.push(`opeType=${parameters.opeType}`);
        }
        this.composeUrl();
    }
}

export interface ICarrierAreasSearchRequest extends ICommandParameters {
    carrierId: number;
    excludeOperationAreasInUse?: boolean;
    opeType?: string;
}
